import { ProductCreateActions as ProductCreate } from "./ProductCreate";
import { combineReducers, createStore, Store } from "lib/store/v3";
import { createStoreLogger } from "lib/store/v3/createStoreLogger";

const reducer = combineReducers({ ProductCreate }, createStoreLogger("ProductCreate"));

export type ProductCreateStore = Store<typeof reducer>;

export const { useSelector: useProductCreateSelector, ...ProductCreateStore } = createStore(reducer);
